import { connect } from 'react-redux';
import App from 'common/backbone-app';
import { SidebarInfo as Component } from './SidebarInfo';
import Wahanda from 'common/wahanda';
import { shouldShowSupportPhoneNumberSelector } from 'utilities/shouldShowSupportPhoneNumber';

const mapStateToProps = (state) => {
  return {
    venueId: App.getVenueId(),
    employeeName: App.config.accountEmployeeName() || App.config.accountFullName(),
    emailAddress: App.config.get('account').emailAddress,
    accountId: App.config.getAccountId(),
    isSelfOnboarding: App.config.isVenuePending() && App.config.get('venue').selfOnboardingEnabled,
    phoneNumber: App.config.get('channel').supplierSupportPhoneNumber,
    shouldShowSupportPhoneNumber: shouldShowSupportPhoneNumberSelector(state),
    // Not via isFeatureEnabled: that selector is typed to the trunk-features
    // registry, and this is a server-side flag with no entry there — the same
    // shape as CD-1277-finance-settings-page and the TEF-* flags. Reconnect's
    // PhoneSupportButton decides the rest; this only keeps it from loading.
    isPhoneSupportEnabled: Wahanda.Features.isEnabled('CPG-premium-phone-support'),
    // The new dashboard's flag: with it on, these links live in the header's help menu.
    isHelpMenuEnabled: Wahanda.Features.isEnabled('ff-all-partner-growth__dashboard-v1'),
  };
};

export const SidebarInfo = connect(mapStateToProps)(Component);
